import { render } from "./Header.vue?vue&type=template&id=8df21f74&scoped=true&lang=pug"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=8df21f74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8df21f74"

export default script